define('components/ecrinbridge/EcrinBridge', [

], function() {

    var config = {};
    var headerHeight;
    var callbacks;

    /*
     * Add config & callback
     */
    var initialize = function(options) {
        config = options.config ? options.config : {};
        callbacks = options.callbacks ? options.callbacks : {};

        if (typeof ecrin !== "undefined" && typeof ecrinOverride !== "undefined") {
            ecrin.sideMenu.toggle = function(callback) {
                var _menuToggled = this.menuToggled = !this.menuToggled;
                $(document).trigger(_menuToggled === true ? "menuOpen" : "menuClose");
                $("body").toggleClass("ecrin-sidemenu-open", this.menuToggled);
                this.$el.one("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd", function() {
                    $(document).trigger(_menuToggled === true ? "menuOpened" : "menuClosed");
                    ecrin.sideMenu.$sideMenuScroll.toggleClass("use-gpu", ecrin.sideMenu.menuToggled);
                });
            };
        }
    };

    /*
     * Return Header Height
     */
    var getHeaderHeight = function() {
        if (!headerHeight) {
            if ($('#ecrin-header').length > 0) {
                headerHeight = $('#ecrin-header').outerHeight();
            } else {
                headerHeight = $('#dior-header').length > 0 ? $('#dior-header').outerHeight() : $('#header').outerHeight();
            }
        }
        return headerHeight;
    };

    /*
     * Show header & go to top
     */
    var showHeader = function( goToTop, animate ) {
        if( goToTop ) {
            if( animate ) {
                $('body,html').animate({
                    scrollTop: 0
                }, 500);
            } else {
                $( 'body, html' ).scrollTop( 0 );
            }
        }

        $('#dior-header').removeClass('hidden');
    };

    /*
     * TODO : USE POPULATE MENU FROM JSON
     */
    var addMenuItems = function(menuItems) {
        $('#ecrin-sidemenu-scroll .main-nav').prepend(menuItems);
    };

    /*
     * Add item to cart
     * e should be an click event on a button that have 2 attributes : data-sku & data-quantity
     * callback is call after Ecrin have executed the add
     */
    var addItemToCart = function(e, callback) {
        // TODO Check this, ugly fix for IE 8 Dior Sauvage
        var eventCopy = $.extend(true, {}, e);

        setTimeout( function() {
            if( callbacks.onAddItemToCartCallback ){
                callbacks.onAddItemToCartCallback( eventCopy );
            }

            if (config.deviceEnv === "desktop" && window.modules.AddToCart) {
                window.modules.AddToCart.Add(eventCopy, callback);
            } else if (config.deviceEnv === "mobile" && window.modules.addToCart) {
                window.modules.addToCart.add($(eventCopy.currentTarget).attr('data-sku'), $(eventCopy.currentTarget).attr('data-quantity'));
                if (_.isFunction(callback)) {
                    callback();
                }
            } else {
                console.warn("[EcrinBridge -> addItemToCart] addToCart unavailable");
                if (_.isFunction(callback)) {
                    callback();
                }
            }
        }, 100);
    };

    /*
     * Add multiple item to cart
     * e should be an click event on a button that have 2 attributes : data-skus & data-quantities
     * callback is call after Ecrin have executed the add
     */
    var addMultipleItemToCart = function(e, callback) {
        if( callbacks.onAddMultipleItemToCartCallback ){
            callbacks.onAddMultipleItemToCartCallback( e );
        }

        if (config.deviceEnv === "desktop" && window.modules.AddToCart) {
            window.modules.AddToCart.AddMultiple(e, callback);
        } else if (config.deviceEnv === "mobile" && window.modules.addToCart) {
            window.modules.addToCart.add($(e.currentTarget).attr('data-skus'), $(e.currentTarget).attr('data-quantities'));
            if (_.isFunction(callback)) {
                callback();
            }
        } else {
            console.warn("[EcrinBridge -> addMultipleItemToCart] addToCart unavailable");
            if (_.isFunction(callback)) {
                callback();
            }
        }
    };

    /*
     * Open newsletter popin in ecrin
     * On desktop & tablet -> autoclose after 2 seconds
     */
    var openNewsletterPopin = function(e, isMobile) {
        if( callbacks.onOpenNewsletterPopinCallback ){
            callbacks.onOpenNewsletterPopinCallback( e );
        }

        setTimeout( _.bind(function() {
            if( isMobile ){
                $('html,body').animate({
                    scrollTop: $(".js-footer-newsletter-email").offset().top},
                'slow');
            } else {
                var $newsletterRoll = $('#newsletterRoll');
                var $newsletterLink = $('#newsletter-trigger a[data-targetroll="newsletterRoll"]');

                if (window.modules.header.rolls) {
                    window.modules.header.rolls.toggle($newsletterRoll, $newsletterLink);

                    if(typeof e !== "undefined") {
                        e.preventDefault();
                        e.stopPropagation();
                    }

                    // Reset Autoclose on Mouse Enter Popin Newsletter
                    $('.js-newsletter-roll').on('mouseenter', _.bind(function(e){
                        clearTimeout(this.autoCloseTimeout);
                    }, this));

                    // AutoClose Popin Newsletter after 2500 ms
                    this.autoCloseTimeout = setTimeout(closeNewsletterPopin, 2000);
                } else {
                    console.warn("[EcrinBridge -> openNewsletterPopin] Newsletter Roll unavailable");
                }
            }
        }, this), 40);
    };

    /*
     * Force close newsletter popin.
     * Only desktop & tablet for now.
     */
    var closeNewsletterPopin = function(e) {
        if (window.modules.header.rolls) {
            window.modules.header.rolls.close();
        } else {
            console.warn("[EcrinBridge -> closeNewsletterPopin] Newsletter Roll unavailable");
        }
    };

     /*
     * Get header scroll
     * For mobile
     * Seems to always return 1
     */
    var getHeaderScroll = function() {
        if ( config.deviceEnv === "mobile" ) {
            return window.ecrin.header.scroll;
        }
    };


    var onMenuOpen = function(callback, options) {
        if ( config.deviceEnv === "mobile" ) {
            $(document).on('menuOpen', _.bind(function(event){
                callback(event, options);
            }, this));
        }
    };

    var onMenuOpened = function(callback, options) {
        if ( config.deviceEnv === "mobile" ) {
            $(document).on('menuOpened', _.bind(function(event){
                callback(event, options);
            }, this));
        }
    };

    var onMenuClose = function(callback, options) {
        if ( config.deviceEnv === "mobile" ) {
            $(document).on('menuClose', _.bind(function(event){
                callback(event, options);
            }, this));
        }
    };

    var onMenuClosed = function(callback, options) {
        if ( config.deviceEnv === "mobile" ) {
            $(document).on('menuClosed', _.bind(function(event){
                callback(event, options);
            }, this));
        }
    };

    return {
        initialize: initialize,
        getHeaderHeight: getHeaderHeight,
        showHeader: showHeader,
        addMenuItems: addMenuItems,
        addItemToCart: addItemToCart,
        addMultipleItemToCart: addMultipleItemToCart,
        openNewsletterPopin: openNewsletterPopin,
        closeNewsletterPopin: closeNewsletterPopin,
        getHeaderScroll: getHeaderScroll,
        onMenuOpen: onMenuOpen,
        onMenuOpened: onMenuOpened,
        onMenuClose: onMenuClose,
        onMenuClosed: onMenuClosed
    };

});
